import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-title text-lg"
};
const _hoisted_2 = {
  class: "flex-1 pr-8 font-medium"
};
const _hoisted_3 = {
  class: "absolute top-1/2 right-8 -translate-y-1/2"
};
import { computed } from 'vue';
import { CloseBold } from '@element-plus/icons-vue';
import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'CenterDialog',
  props: {
    title: {
      default: ''
    },
    modelValue: {
      type: Boolean
    },
    tradeType: {}
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const dialogRef = ref();
    const maxHeight = ref(0);
    onMounted(() => {
      maxHeight.value = window.innerHeight - 160 - 64;
    });
    const contentStyle = computed(() => {
      if (props.tradeType === undefined) return {};
      if (props.tradeType === 1) {
        return {
          backgroundImage: `url(${require('@/assets/images/home-bg-2.png')})`
        };
      }
      return {
        backgroundImage: `url(${require('@/assets/images/home-bg.png')})`
      };
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, _mergeProps(_ctx.$attrs, {
        modelValue: __props.modelValue,
        title: "",
        "show-close": false,
        "close-on-click-modal": false,
        class: "p-none dialog-center",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => emits('update:modelValue', $event))
      }), {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "content-block flex flex-col",
          style: _normalizeStyle(contentStyle.value)
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "header", {}, () => [_createTextVNode(_toDisplayString(__props.title), 1)])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_icon, {
          class: "cursor-pointer close-icon",
          size: "16",
          color: "#86909C",
          onClick: _cache[0] || (_cache[0] = $event => emits('update:modelValue', false))
        }, {
          default: _withCtx(() => [_createVNode(_unref(CloseBold))]),
          _: 1
        })])]), _createElementVNode("div", {
          class: "center-content flex-1",
          ref_key: "dialogRef",
          ref: dialogRef
        }, [_renderSlot(_ctx.$slots, "default", {
          maxHeight: maxHeight.value
        })], 512)], 4)]),
        _: 3
      }, 16, ["modelValue"]);
    };
  }
});